var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.400391,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#00AFF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7105 34.4002C26.3882 34.6067 25.0359 34.4981 23.7635 34.0832C22.4911 33.6683 21.3346 32.9588 20.3883 32.0124C19.442 31.0661 18.7324 29.9096 18.3175 28.6372C17.9026 27.3648 17.794 26.0125 18.0005 24.6902C17.4793 23.6987 17.2888 22.5664 17.457 21.459C17.6251 20.3515 18.1431 19.3268 18.9352 18.5348C19.7272 17.7427 20.7519 17.2247 21.8594 17.0566C22.9668 16.8884 24.0991 17.0789 25.0905 17.6002C26.4128 17.3936 27.7652 17.5022 29.0376 17.9171C30.31 18.3321 31.4665 19.0416 32.4128 19.9879C33.3591 20.9343 34.0687 22.0907 34.4836 23.3631C34.8985 24.6355 35.0071 25.9879 34.8005 27.3102C35.3218 28.3016 35.5123 29.4339 35.3441 30.5413C35.176 31.6488 34.658 32.6735 33.8659 33.4655C33.0739 34.2576 32.0492 34.7756 30.9417 34.9437C29.8343 35.1119 28.702 34.9214 27.7105 34.4002ZM26.4535 31.1562H26.4135C29.2855 31.1562 30.7165 29.7702 30.7165 27.9132C30.7165 26.7152 30.1655 25.4422 27.9905 24.9552L26.0075 24.5152C25.2525 24.3432 24.3855 24.1152 24.3855 23.4002C24.3855 22.6852 25.0055 22.1872 26.1095 22.1872C28.3395 22.1872 28.1365 23.7152 29.2405 23.7152C29.8165 23.7152 30.3335 23.3732 30.3335 22.7852C30.3335 21.4152 28.1365 20.3852 26.2775 20.3852C24.2565 20.3852 22.1045 21.2442 22.1045 23.5292C22.1045 24.6272 22.4985 25.7992 24.6645 26.3422L27.3535 27.0132C28.1695 27.2152 28.3715 27.6722 28.3715 28.0852C28.3715 28.7722 27.6875 29.4432 26.4535 29.4432C24.0365 29.4432 24.3755 27.5862 23.0795 27.5862C22.4995 27.5862 22.0765 27.9842 22.0765 28.5572C22.0765 29.6712 23.4285 31.1562 26.4535 31.1562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkype);
export default __webpack_public_path__ + "static/media/skype.f4127a05910d9145ad9cde2a4ac7d296.svg";
export { ForwardRef as ReactComponent };